import { Fragment, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Popover, Transition } from '@headlessui/react';
import { BarsArrowDownIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/outline';
import { toast } from 'react-hot-toast';

import { ModalDeleteMessageMuro } from './ModalDeleteMessageMuro';
import { deleteNoticeMessages } from '../../../redux/actions/noticeMessage';

export const MessageMenuMuro = ({ messaageMuroId, canEdit = false, onEdit }) => {
    const dispatch = useDispatch();
    const [openModalDeleteMessageMuro, setOpenModalDeleteMessageMuro] = useState(false);
    const [loadingDeleteMessageMuro, setLoadingDeleteMessageMuro] = useState(false);
    const cancelDeleteMessageMuroRef = useRef(null);

    const handleConfirmDeleteMessageMuro = () => {
        setLoadingDeleteMessageMuro(true);
        dispatch(deleteNoticeMessages(messaageMuroId))
            .then((result) => {
                if (result?.status === 200) {
                    toast.success(result.message);
                    setOpenModalDeleteMessageMuro(false);
                } else {
                    toast.error(result?.message || 'No se pudo eliminar el aviso.');
                    setOpenModalDeleteMessageMuro(false);
                }
            })
            .catch(() => {
                toast.error('No se pudo eliminar el aviso.');
                setOpenModalDeleteMessageMuro(false);
            })
            .finally(() => {
                setLoadingDeleteMessageMuro(false);
            });
    };

    return (
        <>
            <Popover className="relative">
                {() => (
                    <>
                        <Popover.Button
                            className="inline-flex h-9 w-9 items-center justify-center rounded-full text-gray-500 hover:bg-slate-100 hover:text-indigo-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                            aria-label="Opciones del aviso"
                        >
                            <BarsArrowDownIcon className="w-4 h-4" aria-hidden="true" />
                        </Popover.Button>
                        <Transition
                            as={Fragment}
                            enter="transition ease-out duration-200"
                            enterFrom="opacity-0 translate-y-1"
                            enterTo="opacity-100 translate-y-0"
                            leave="transition ease-in duration-150"
                            leaveFrom="opacity-100 translate-y-0"
                            leaveTo="opacity-0 translate-y-1"
                        >
                            <Popover.Panel className="absolute z-10 -translate-x-[90%] transform w-[200px]">
                                <div className="overflow-hidden rounded-lg shadow-md shadow-indigo-900/10 ring-1 ring-black/5">
                                    <div className="relative flex flex-col gap-1 bg-white p-2">
                                        {canEdit && onEdit ? (
                                            <button
                                                type="button"
                                                onClick={onEdit}
                                                className="w-full flex justify-around items-center p-2 rounded-md hover:bg-gray-100"
                                            >
                                                <PencilSquareIcon className="w-[16px]" />
                                                <p>Editar aviso</p>
                                            </button>
                                        ) : null}
                                        <button
                                            type="button"
                                            onClick={() => setOpenModalDeleteMessageMuro(true)}
                                            className="w-full flex justify-around items-center p-2 rounded-md hover:bg-gray-100"
                                        >
                                            <TrashIcon className="w-[16px]" />
                                            <p>Borrar aviso</p>
                                        </button>
                                    </div>
                                </div>
                            </Popover.Panel>
                        </Transition>
                    </>
                )}
            </Popover>
            <ModalDeleteMessageMuro
                open={openModalDeleteMessageMuro}
                setOpen={setOpenModalDeleteMessageMuro}
                cancelButtonRef={cancelDeleteMessageMuroRef}
                confirmAction={handleConfirmDeleteMessageMuro}
                loadingDeleteMessage={loadingDeleteMessageMuro}
                title="¿Seguro que quieres borrar este aviso?"
                labelButonConfirm="Borrar aviso"
            />
        </>
    );
};
